import { CircularProgress } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import Layout from 'components/Layout';
import localstorageKeys from 'constants/localstorageKeys';
import { getLocalStorageItem } from 'hooks';
import { useAuthMe } from 'queries/AuthQueries';
import React, { Suspense, useMemo } from 'react';
import { useIsMutating } from 'react-query';
import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';

import { routeKey, routes } from './RouteConstants';

const ProtectedRoutes = () => {
  const location = useLocation();
  const isLoggedIn = getLocalStorageItem(localstorageKeys.AUTH_TOKEN);
  const userRoles = getLocalStorageItem('roles');
  const { data: profileData } = useAuthMe();

  const currentRouteKey = routeKey[location.pathname];
  const currentRoute = routes[currentRouteKey];

  if (!currentRoute) {
    return <Navigate to={routes['404'].pathname} />;
  }

  if (!isLoggedIn && !currentRoute.isPublic) {
    return <Navigate to={routes.LOGIN.pathname} />;
  }

  if (currentRoute.authorizedRoles) {
    const isAuthorized = userRoles?.roles?.some((role: any) =>
      currentRoute.authorizedRoles.includes(role)
    );

    if (!isAuthorized) {
      return <Navigate to={routes['404'].pathname} />;
    }
  }

  const restrictedRoutes = ['/patients', '/inbox', '/requests'];
  const hasPatientAccessKey =
    profileData?.data?.account?.patientsAccessKey ||
    userRoles?.account?.patientsAccessKey;

  if (!hasPatientAccessKey && restrictedRoutes.includes(location.pathname)) {
    return <Navigate to={routes['404'].pathname} />;
  }

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

// const ProtectedRoutes = () => {
//   const location = useLocation();

//   const isLoggedIn = getLocalStorageItem(localstorageKeys.AUTH_TOKEN);
//   return isLoggedIn ? (
//     <Layout>
//       <Outlet />
//     </Layout>
//   ) : (
//     <Navigate to={routes.LOGIN.pathname} replace state={{ from: location }} />
//   );
// };

const RoutesPage = () => {
  const location = useLocation();
  const PublicRoutes = useMemo(
    () => (
      <>
        {Object.values(routes)
          .filter(
            (routeDetails) => routeDetails.isPublic && routeDetails.element
          )
          .map((routeDetails) => (
            <Route
              key={`public-route-${routeDetails.pathname}`}
              path={routeDetails.pathname}
              element={
                <Suspense fallback={null}>{routeDetails.element}</Suspense>
              }
            />
          ))}
      </>
    ),
    []
  );

  const PrivateRoutes = useMemo(
    () => (
      <>
        {Object.values(routes)
          .filter(
            (routeDetails) => !routeDetails.isPublic && routeDetails.element
          )
          .map((routeDetails) => (
            <Route
              key={`private-route-${routeDetails.pathname}`}
              path={routeDetails.pathname}
              element={
                <Suspense fallback={null}>{routeDetails.element}</Suspense>
              }
            />
          ))}
      </>
    ),
    []
  );
  const mutatingAPICount = useIsMutating();

  const shouldShowBackdrop =
    Boolean(mutatingAPICount) && location.pathname !== '/messaging';
  const mutatingAPIBackdrop = shouldShowBackdrop ? (
    <Backdrop
      open={true}
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 100,
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
      }}
    >
      <CircularProgress className="text-[#68D2DF]" />
    </Backdrop>
  ) : null;
  return (
    <>
      {mutatingAPIBackdrop}
      <Routes>
        {PublicRoutes}
        <Route element={<ProtectedRoutes />}>{PrivateRoutes}</Route>
        {/* <Route path="*" element={<DefaultScreen />} /> */}
      </Routes>
    </>
  );
};

export default RoutesPage;
